import get from 'lodash/get';

export function getImage(data, width = null) {
    return get(
        data,
        getImageSource(data.image, width),
    );
}

export function getImageSource(image, width = null) {
    if (!image) {
        return null;
    }

    if (image.versions) {
        switch (true) {
        case (width <= 400):
            return image.versions.w400 || image.source;
        case (width <= 700):
            return image.versions.w700 || image.source;
        case (width <= 1200):
            return image.versions.w1200 || image.source;
        default:
            return image.source;
        }
    }

    return image.source;
}
